module.exports = __webpack_public_path__ + "img/invoice-de-female-bw.1039adc0.png";